import React from 'react';
import Slider from 'rc-slider';
import Tooltip from 'rc-tooltip';


const Handle = Slider.Handle;

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};


class BSSlider extends React.Component{
  constructor(props) {
    super(props)

    this.state = {
     value: this.props.value
    }

   }


      onBSChange = async (e) =>{
        let result = e.target.value;
        if(result > this.props.max){
          result = this.props.max;
        }
        if(result < this.props.min || Number.isNaN(result) === true){
          result = this.props.min;
        }

        this.setState({
            value: result
        });
        this.props.onSliderChange(this.props.name, e.target.value);
      };



    onBSSliderChange = async (e) =>{
      let result = parseFloat(e);
      if(e > this.props.max){
        e = this.props.max;
      }
      if(e < this.props.min){
        e = this.props.min;
      }
      

      this.setState({
          value: e
      });


      this.props.onSliderChange(this.props.name, e);
    }



    render() {
      return (
        <div className="BSInput">
        <Slider min={this.props.min} max={this.props.max} step={this.props.steps ? this.props.steps : 1} value={this.state.value} onChange={this.onBSSliderChange} handle={handle}   />
              <input 
                name={this.props.name} 
                onChange={this.onBSChange} 
                value={this.state.value}
                type="number"
                
              />  
              <span className="BSInput-me">px</span>
        </div>
      );
    };
}

export default BSSlider;